import { Checkbox, CheckboxProps, ExpandableSection } from '@amzn/awsui-components-core';
import React from 'react';
import ChecklistInfo from '../../model/ChecklistInfo';

interface Props {
  checkedStatus: boolean[];
  checklistIndex: number;
  checklistInfo: ChecklistInfo;
  onChecked?: (listIndex: number, itemIndex: number, checked: boolean) => void;
}

const Checklist: React.FunctionComponent<Props> = (props: Props) => {
  const { checklistIndex, checklistInfo, onChecked, checkedStatus } = props;
  const { header, items, instruction } = checklistInfo;
  const uncheckedItemsCount = checkedStatus.filter((itemStatus) => !itemStatus).length;

  const handleCheckboxChanged = (itemIndex: number, detail: CheckboxProps.ChangeDetail) => {
    if (onChecked) {
      onChecked(checklistIndex, itemIndex, detail.checked);
    }
  };

  const showCheckboxes = items.map((item, index) => {
    return (
      <Checkbox
        // eslint-disable-next-line react/no-array-index-key
        key={`${checklistIndex}-${index}`}
        // @ts-expect-error TS2322 - strict migration
        checked={checkedStatus[index]}
        onChange={({ detail }) => handleCheckboxChanged(index, detail)}
      >
        {item}
      </Checkbox>
    );
  });

  const checklistHeader = (
    <span>
      {header} <span className="item-unchecked-count">{`(${uncheckedItemsCount})`}</span>
    </span>
  );

  return (
    <ExpandableSection header={checklistHeader} defaultExpanded>
      {instruction}
      {showCheckboxes}
    </ExpandableSection>
  );
};

export default Checklist;
